import {MedicationSchemeEffects} from './medication.effect';
import {DiaryNotesEffects} from './diary-notes-effect';
import { PrescriptionsEffects } from './prescription.effect';
import { UserEffects } from './user.effect';
import { DeliveredMedicationsEffects } from './delivered-medications.effect';

export const effects = [
  MedicationSchemeEffects,
  DiaryNotesEffects,
  PrescriptionsEffects,
  DeliveredMedicationsEffects,
  UserEffects,
];
